import React from 'react';
import './createAPI.css'; // Import the CSS file

const CreateAPI = () => {
  return (
    <div id="createAPI" className="createAPI-animation"></div>
  );
}

export default CreateAPI;